import { DashboardWidgetConfig } from '@dashboard-widget/dashboard-widget.types';
import { createAction, props } from '@ngrx/store';

const tag = '[Dashboard Widget Configuration] Api' ;

export const getDashboardWidgetConfiguration = createAction( `${tag} Get`, props<{widgetId: number }>());

export const getDashboardWidgetConfigurationComplete = createAction(
  `${tag} Get Complete`,
  props<{widgetId: number; config: any}>());

export const saveDashboardWidgetConfiguration = createAction(`${tag} Save`, props<{ widgetId: number; config: any }>());
